module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-error-create-quote-dg"\n     style="display: none">\n    <div class="errorCreateQuoteDg__content">\n        <div class="errorCreateQuoteDg__content-icon"></div>\n\n        <div class="errorCreateQuoteDg__content-title">\n            Что-то пошло не так...\n        </div>\n\n        <div class="errorCreateQuoteDg__content-subtitle">\n            ';
 if (typeof message !== 'undefined' && message) { 
__p+=''+
((__t=( message ))==null?'':_.escape(__t))+
'';
 } else { 
__p+='К сожалению произошла ошибка.<br/> Попробуйте перезагрузить страницу';
 } 
__p+='\n        </div>\n\n        <div class="errorCreateQuoteDg__content-button js-reload-page">\n            Перезагрузить\n        </div>\n    </div>\n</div>\n';
}
return __p;
};
